import {
  parseProject,
  placedPdfSchema,
  type Project,
  type PlacedPdf,
} from "./schema";

/** Replace artwork without copying inherited part data or changing frame geometry. */
export function replacePdfArtwork(
  project: Project,
  pageId: string,
  nodeId: string,
  input: PlacedPdf,
  options: { keepPlacement?: boolean } = {},
): Project {
  const artwork = placedPdfSchema.parse(input);
  const selected = project.pages
    .find((page) => page.id === pageId)
    ?.nodes.find((node) => node.id === nodeId);
  if (!selected || selected.type !== "image")
    throw new Error("Select an image layer");
  const field = project.fields.find((field) => field.id === selected.fieldId);
  if (field && !["image", "image-list"].includes(field.type))
    throw new Error("The layer must use an image variable");
  if (
    field?.type === "image-list" &&
    !field.choices.some((choice) => choice.value === field.default)
  )
    throw new Error(
      "Choose a local default image option before replacing its PDF artwork",
    );
  return parseProject({
    ...project,
    fields: project.fields.map((current) =>
      current.id !== field?.id
        ? current
        : current.type === "image-list"
          ? {
              ...current,
              choices: current.choices.map((choice) =>
                choice.value === current.default
                  ? { ...choice, assetId: artwork.assetId }
                  : choice,
              ),
            }
          : { ...current, default: artwork.assetId },
    ),
    pages: project.pages.map((page) => ({
      ...page,
      nodes: page.nodes.map((node) =>
        node.type === "image" &&
        ((page.id === pageId && node.id === nodeId) ||
          (!!field && node.fieldId === field.id))
          ? {
              ...node,
              content: field ? node.content : artwork.assetId,
              placedPdf: artwork,
              imagePlacement: options.keepPlacement
                ? node.imagePlacement
                : undefined,
            }
          : node,
      ),
    })),
    outputs: project.outputs.map((output) =>
      output.format === "pdf"
        ? { ...output, preserveImportedPdf: true }
        : output,
    ),
  });
}
